(() => {
  const toggles = document.querySelectorAll('[data-footer-accordion-toggle]');
  const contents = document.querySelectorAll('[data-footer-accordion-content]');

  // A partir de 750px el CSS fuerza el contenido del acordeon a estar
  // siempre visible (max-height: none !important — ver footer.liquid),
  // sin pasar por el toggle de abajo. El HTML sale con inert puesto por
  // defecto (estado "cerrado" de movil) y nada lo quitaba en desktop:
  // los links se veian pero quedaban muertos al clic/tab. Sincroniza
  // inert con el breakpoint real, no solo con el click del acordeon.
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  const syncDesktopInert = () => {
    contents.forEach((content) => {
      content.inert = !desktopQuery.matches && content.getAttribute('aria-hidden') === 'true';
    });
  };
  syncDesktopInert();
  desktopQuery.addEventListener('change', syncDesktopInert);

  toggles.forEach((toggle) => {
    const content = toggle.nextElementSibling;
    if (!content) return;

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      content.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      content.inert = !desktopQuery.matches && isOpen;
      // Altura real del contenido, no un max-height fijo — evita que
      // columnas cortas se vean con un hueco vacio enorme al abrir.
      content.style.maxHeight = isOpen ? '' : content.scrollHeight + 'px';
    });
  });

  // ── Pais/idioma: popup pequeño en vez de <select> nativo ────────────────
  // La columna vive dentro del acordeon del footer (overflow:hidden para
  // animar el alto), asi que el panel es position:fixed y su sitio lo
  // calculamos aqui con getBoundingClientRect del boton — position:
  // absolute se recortaba con el overflow del acordeon (ver footer.liquid).
  const locToggles = document.querySelectorAll('[data-loc-toggle]');

  const positionLocPanel = (toggle, panel) => {
    const rect = toggle.getBoundingClientRect();
    const panelWidth = Math.min(320, window.innerWidth * 0.88);
    // Pegado a la izquierda del boton, sin salirse del viewport a la derecha.
    const left = Math.min(rect.left, window.innerWidth - panelWidth - 12);
    panel.style.left = Math.max(12, left) + 'px';
    panel.style.bottom = (window.innerHeight - rect.top + 12) + 'px';
  };

  const closeAllLocPanels = (except) => {
    locToggles.forEach((toggle) => {
      const panel = toggle.nextElementSibling;
      if (!panel || panel === except) return;
      toggle.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
    });
  };

  locToggles.forEach((toggle) => {
    const panel = toggle.nextElementSibling;
    if (!panel) return;

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = panel.classList.contains('is-open');
      closeAllLocPanels(isOpen ? null : panel);
      if (!isOpen) positionLocPanel(toggle, panel);
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.classList.toggle('is-open', !isOpen);
      panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      panel.inert = isOpen;
    });
  });

  if (locToggles.length) {
    document.addEventListener('click', () => closeAllLocPanels());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllLocPanels();
    });
    // Si cambia el tamaño de ventana con un panel abierto, se cierra en
    // vez de quedarse mal colocado (mas simple que recalcular en vivo).
    window.addEventListener('resize', () => closeAllLocPanels());
  }

  const copyrightOpenBtn = document.querySelector('[data-copyright-open]');
  const copyrightModal = document.querySelector('[data-copyright-modal]');

  if (copyrightOpenBtn && copyrightModal) {
    copyrightOpenBtn.addEventListener('click', () => {
      copyrightModal.hidden = false;
    });
    copyrightModal.querySelectorAll('[data-copyright-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        copyrightModal.hidden = true;
      });
    });
  }
})();
